<script>
  import Fa from "svelte-fa";
  import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
  import EditableField from "../EditableField.svelte";
  import ChooseCategory from '../ChooseCategory.svelte';

  /**
    *  @type {import('../proto/products_pb').Product}
    */
  export let product;
  /**
   * @type {(product: import('../proto/products_pb').Product) => void}
   */
  export let updateProduct;
  /**
   * @type {(product: import('../proto/products_pb').Product) => void}
   */
  export let deleteProduct;
  console.log(product);

  /**
   * @param {import('../proto/products_pb').Product} product
   * @param {number} price
   */
  function updateProductPrice(product, price) {
    product.setPrice(price);
    updateProduct(product);
    console.log('updating product price');
  }

  /**
   * @param {import('../proto/products_pb').Product} product
   * @param {number} discountedPrice
   */
  function updateProductDiscountedPrice(product, discountedPrice) {
    product.setDiscountedprice(discountedPrice);
    updateProduct(product);
    console.log('updating product discounted price');
  }

  /**
   * @param {import('../proto/products_pb').Product} product
   * @param {string} name
   */
  function updateProductName(product, name) {
    product.setName(name);
    updateProduct(product);
  }

  /**
   * @param {import('../proto/products_pb').Product} product
   * @param {string} description
   */
  function updateDescription(product, description) {
    product.setDescription(description);
    updateProduct(product);
  }

  /**
   * @param {import('../proto/products_pb').Product} product
   * @param {string} category
   */
  function updateProductCategory(product, category) {
    product.setCategory(category);
    updateProduct(product);
  }
</script>

<div class="p-4 bg-white rounded-lg shadow-lg">
<div class="flex justify-between items-center mb-4">
  <span class="font-bold text-lg">Редактирай продукт</span>
</div>
<div class="flex flex-col items-center">
  <div class="w-32 h-32 mb-4">
    <img
      src={product.getUrl()}
      alt={product.getName()}
      class="w-full h-full object-contain rounded"
    />
  </div>
  <div class="w-full">
    <EditableField
      initialValue={product.getPrice().toFixed(2)}
      viewClass="text-2xl font-bold block w-full text-center mb-2"
      editClass="text-2xl font-bold block w-full text-center mb-2"
      validate={(value) => value.length > 0 && !isNaN(value)}
      on:update={(value) => updateProductPrice(product, value.detail)}
    />
    <EditableField
      initialValue={product.getDiscountedprice().toFixed(2)}
      viewClass="text-2xl font-bold block w-full text-center mb-2 text-red-500"
      editClass="text-2xl font-bold block w-full text-center mb-2 text-red-500"
      validate={(value) => value.length > 0 && !isNaN(value)}
      on:update={(value) => updateProductDiscountedPrice(product, value.detail)}
    />
    <EditableField
      initialValue={product.getName()}
      viewClass="text-sm block w-full text-center mb-2"
      editClass="text-sm block w-full text-center mb-2"
      validate={(value) => value.length > 0}
      on:update={(value) => updateProductName(product, value.detail)}
    />
    <div class="py-4">
      <ChooseCategory category={product.getCategory()} setCategory={(selectedSubcategory) => updateProductCategory(product, selectedSubcategory)}></ChooseCategory>
    </div>
    <EditableField
      initialValue={product.getDescription()}
      viewClass="text-sm block w-full text-center mb-2 h-[32em]"
      editClass="text-sm block w-full text-center mb-2 h-[32em] overflow-hidden"
      validate={(value) => value.length > 0}
      on:update={(value) => updateDescription(product, value.detail)}
      isTextarea={true}
    />
  </div>
</div>
  <button class="text-red-500 bg-red-100 hover:bg-red-200 button" on:click={() => deleteProduct(product)}>
    <Fa icon={faTrashCan} size="1x" />
    Изтрий продукт
  </button>
</div>